module.exports = __webpack_public_path__ + "img/spacefoodsticks-hero.22cf2a84.png";